import MsgBody, { MsgPlaceholder } from './MsgBody';

export default MsgBody;

export {
  MsgPlaceholder,
};
